import React from "react";

const Appointment = () => {
  return (
    <section id="service">
      <div className="container mx-auto px-6 text-center">
        {/* Single button */}
        <a
          href="https://calendar.app.google/BBXVdwFStqB3HFEL7" // replace with your actual link
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-accent hover:bg-accent-hover text-white px-8 py-4 rounded-xl font-semibold text-lg shadow-md transition-all duration-300"
          id="consultation"
        >
          Schedule a Consultation
        </a>

        {/* Simple, short disclaimer */}
        <p className="text-xs text-gray-500 mt-3">
          Disclaimer: This website provides general information and does not
          constitute legal advice. Viewing this site or contacting Cire Legal
          does not create an attorney-client relationship.{" "}
        </p>
      </div>
    </section>
  );
};

export default Appointment;
